export default new class {
    getLocalDevelopment() {
        return sessionStorage.getItem('localDevelopment') && JSON.parse(sessionStorage.getItem('localDevelopment'));
    }
};
